module.exports = __webpack_public_path__ + "media/category_icons/EENT-727c4934.svg";